(function ($){
	$(document).ready(function(){
		CourseReport.init();
	});

	var CourseReport = {
		$elements: {},

		init: function(){
			// Get main element
			this.$elements.container = $( '#uo-ucec-course-report' );
			this.$elements.table     = $( '#uo-ucec-course-report-table' );

			// Check if the element exists
			if ( this.$elements.table.length > 0 ){
				// Create DataTable
				this.dataTables();
			}
		},

		dataTables: function(){
			// Object reference
			let _this = this;

			// Create instance of DataTables
			this.$elements.table.DataTable({
				dom: 'tip',
				order: [ [ 0, 'asc' ] ],
				paging: false,
				scrollX: true,  // Enable horizontal scrolling
				autoWidth: false,  // Prevent auto-resizing columns
				responsive: false,  // Disable responsive behavior
				fixedHeader: false,  // Disable fixed header
				columnDefs: [
					{
						orderable: false, 
						targets: 4,
					},
				],
				initComplete: function(){
					// Add ready class
					_this.$elements.container.addClass( 'ucec-report--datatables-ready' );
				}
			});
			// Ensure column and body alignment.
			this.forceAlignHeaderWithBody();
			$(window).on('resize', _this.forceAlignHeaderWithBody);
		},

		forceAlignHeaderWithBody: function(){
			const $container = $( '#uo-ucec-course-report' );
			setTimeout(function () {
				let $bodyTable = $('.dataTables_scrollBody table', $container);
				let bodyWidth = $bodyTable.outerWidth();		
				// Sync the header width to match the body
				$('.dataTables_scrollHeadInner', $container).width(bodyWidth);
			}, 50);
		}
	}
})(jQuery);